import { Routes } from '@angular/router';
import { PartnerComponent } from './container/partner.component';

export const PARTNERS_ROUTES: Routes = [
    {
        path: ':slug',
        component: PartnerComponent,
    },
];
